import { deepCopy } from 'deep-copy-ts';

export const deepClone = (original: any): any => deepCopy(original);
